<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <h3 class="text-gray-600"><i class="fas fa-tasks me-2"></i>Add New Audit Template</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active text-primary">
                                <i class="fas fa-building me-2" aria-hidden="true"></i>Audit Template Details
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <form *ngIf="addAuditTemplateFormGroup" (submit)="addAuditTemplate()" [formGroup]="addAuditTemplateFormGroup">
                <error-message [errors]="errors"></error-message>
                        <div class="row mt-3">
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label text-primary">
                                        Description
                                    </label>
                                    <input type="text" class="form-control" formControlName="description" />
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="form-group">
                                    <label class="control-label text-primary">
                                        Category
                                    </label>
                                    <select name="auditCategoryId" class="form-control" formControlName="auditCategoryId">
                                        <option *ngFor="let auditCategory of auditCategoryList" [value]="auditCategory.id">{{auditCategory.description}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-6 col-lg-4">
                                <label class="control-label text-primary">
                                    Is Active
                                </label>
                                <input type="checkbox" id="isActive" name="isActive" class="form-control" formControlName="isActive" appToggle />
                            </div>
                            <div class="col-md-3">
                                <label class="control-label text-primary">
                                   Recurrence (number of months)
                                </label>
                                <input type="number" id="recurrence" name="recurrence" class="form-control" formControlName="recurrence" />
                            </div>
                        </div>

                    <footer class="panel-footer mt-3">
                        <div class="row">
                            <div class="col-12 text-end">
                                <button class="btn btn-outline-primary" type="button" (click)="onBack()">Back</button>
                                <button class="btn btn-success ms-2" type="submit" [disabled]="!addAuditTemplateFormGroup.valid">Save</button>
                            </div>
                        </div>
                    </footer>
            </form>
        </div>
    </div>
</section>

